import classNames from 'classnames';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { GroupButtons, Button } from '@mssgme/ui';
import { CardPreview, usePreview } from '../../UI';
import IconClose from '@mssgme/ui/icons/close.svg';
import IconHand from '@mssgme/ui/icons/logo.svg';

import styles from './styles.scss';

export default function WidgetCard() {
    const { t } = useTranslation('cards');
    const { preview } = usePreview();

    const [isPresented, setIsPresented] = useState(false);

    return (
        <div className={styles.root}>
            <div className={styles.wrapper}>
                <div className={styles.groupButtonsContainer}>
                    <GroupButtons align="center" bordered>
                        <Button
                            btnStyle={isPresented ? 'primary' : 'transparent'}
                            size="small"
                            noborder
                            onClick={() => setIsPresented(true)}
                        >
                            {t('widgetCard.opened')}
                        </Button>
                        <Button
                            btnStyle={isPresented ? 'transparent' : 'primary'}
                            size="small"
                            noborder
                            onClick={() => setIsPresented(false)}
                        >
                            {t('widgetCard.closed')}
                        </Button>
                    </GroupButtons>
                </div>
                <div className={styles.content}>
                    <div
                        className={classNames(styles.cardContainer, {
                            [styles.cardVisible]: isPresented,
                        })}
                    >
                        <CardPreview widgetMode />
                    </div>
                    {!isPresented && preview.widget.welcome.enabled && (
                        <div
                            className={classNames(styles.welcome, {
                                [styles.left]: preview.widget.position === 'left',
                                [styles.right]: preview.widget.position === 'right',
                            })}
                        >
                            <h6>{preview.widget.welcome.headline}</h6>
                            <p>{preview.widget.welcome.description}</p>
                        </div>
                    )}
                </div>
                <div
                    className={classNames(styles.widgetButtonContainer, {
                        [styles.left]: preview.widget.position === 'left',
                        [styles.right]: preview.widget.position === 'right',
                    })}
                >
                    <div
                        className={classNames(styles.welcome, {
                            [styles.left]: preview.widget.position === 'left',
                            [styles.right]: preview.widget.position === 'right',
                            [styles.visibleWelcome]: !isPresented && preview.widget.welcome.enabled,
                        })}
                    >
                        <h6>{preview.widget.welcome.headline}</h6>
                        <p>{preview.widget.welcome.description}</p>
                    </div>

                    <span
                        className={styles.widgetButton}
                        style={{ backgroundColor: preview.widget.color }}
                        onClick={() => setIsPresented(!isPresented)}
                    >
                        <IconClose
                            className={classNames(styles.icon, styles.close, {
                                [styles.visible]: isPresented,
                            })}
                        />
                        <IconHand
                            className={classNames(styles.icon, styles.hand, {
                                [styles.visible]: !isPresented,
                            })}
                        />
                    </span>
                </div>
            </div>
        </div>
    );
}
